import { useState } from "react";
import * as APIModels from "../../../models";
import { SubmissionService } from "../../../services/SubmissionService";
import PreviewFileManager from "./PreviewFileManager";

export default function NewCaseEFileSummary({
    upload,
    setUpload,
}: {
    upload: APIModels.UploadNewCase;
    setUpload?: (upload: APIModels.eFile) => void;
}) {
    const [generate, setGenerate] = useState(false);
    const [textArea, setTextArea] = useState("");
    const [hasFees, setHasFees] = useState(false);
    const [hasWaiver, setHasWaiver] = useState(false);

    const onGenerate = () => {
        console.log("OnGenerateChanged");
        SubmissionService.previewNewcase({
            id: upload.id!,
            body: upload!,
        }).then((resp) => {
            console.log("Kicked off Job");
            setGenerate(true);
        });
    };

    const onComplete = () => {
        console.log("OnGenerateComplete");
        setGenerate(false);
    };

    const handleTextAreaChange = (
        event: React.ChangeEvent<HTMLTextAreaElement>
    ) => {
        const newValue = event.target.value;

        setTextArea(newValue);
        setUpload?.({
            ...upload,
            notes: newValue,
        });
    };

    return (
        <>
            <div className="row">
                <div className="col-6">
                    <div className="mb-2">
                        <label htmlFor="upoadFilename" className="form-label">
                            Documents
                        </label>
                        <table>
                            {upload.documents?.map((v) => (
                                <tr>
                                    <td>
                                        {v.documentType === "" ? (
                                            <b>eFileMadeEasy Template:</b>
                                        ) : (
                                            <b>{v.documentType}:</b>
                                        )}
                                    </td>
                                    <td>{v.filename}</td>
                                </tr>
                            ))}
                        </table>
                    </div>
                    {upload.exhibits &&
                        upload.exhibits.filenames &&
                        upload.exhibits.filenames.length >= 1 && (
                            <div className="mb-2">
                                <label
                                    htmlFor="exampleInputPassword1"
                                    className="form-label"
                                >
                                    Exhibits
                                </label>

                                <ul>
                                    {" "}
                                    {upload.exhibits.filenames.map((v) => (
                                        <li>{v}</li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    <div className="mb-2">
                        <label htmlFor="attorneyName" className="form-label">
                            Attorney Filing on Behalf Of
                        </label>
                        <input
                            type="name"
                            className="form-control"
                            id="attorneyName"
                            value={upload.attorneyName}
                            readOnly
                        />
                    </div>
                </div>
                <div className="col-6">
                    <label htmlFor="multiline-textbox" className="form-label">
                        eFiling Rules (If Needed)
                    </label>
                    <textarea
                        id="multiline-textbox"
                        className="form-control"
                        value={textArea}
                        onChange={handleTextAreaChange}
                        rows={5} // Number of visible text lines
                        cols={50} // Width of the text area
                        maxLength={256}
                        placeholder="Type your text here..."
                        style={{
                            resize: "both", // Allow resizing both horizontally and vertically
                        }}
                    />
                    {textArea.length}/256 Limit
                    <div
                        className="form-check"
                        style={{
                            position: "relative",

                            left: "80%",
                        }}
                    >
                        <input
                            className="form-check-input"
                            id="ckEmergency"
                            type="checkbox"
                            checked={hasFees}
                            onChange={(event) => {
                                setHasFees(event.currentTarget.checked);
                                setUpload?.({
                                    ...upload,
                                    hasFees: event.currentTarget.checked,
                                });
                            }}
                        />
                        <label
                            className="form-check-label"
                            htmlFor="ckOverride"
                        >
                            Has Fees?
                        </label>
                    </div>
                    <div
                        className="form-check"
                        style={{
                            position: "relative",

                            left: "80%",
                        }}
                    >
                        <input
                            className="form-check-input"
                            id="ckEmergency"
                            type="checkbox"
                            checked={hasWaiver}
                            onChange={(event) => {
                                setHasWaiver(event.currentTarget.checked);
                                setUpload?.({
                                    ...upload,
                                    hasWaiver: event.currentTarget.checked,
                                });
                            }}
                        />
                        <label
                            className="form-check-label"
                            htmlFor="ckOverride"
                        >
                            Has Waiver?
                        </label>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-12"></div>
            </div>
            <div className="row">
                <div className="col-12" style={{ fontWeight: "bolc" }}>
                    The filing attorney has the responsibility to ensure that
                    any confidential information in the filled documents
                    compiles with all state rules,statues, and codes. By
                    clicking the Submit button below you are acknowledging that
                    you have redacted or prepared the attached document(s) in
                    accordance with all state confidentiality requirements.
                    eFileMadeEasy does not check or redact any information.
                </div>
            </div>
        </>
    );
}
